<template>
  <div class="aside-content">
    <div class="hos">
      <div style="width:90px; height:90px;">
        <img v-if="logo" :src="logo" alt="" />
      </div>
      <span>{{ name }}</span>
    </div>
    <el-menu
      class="el-menu-vertical-demo"
      @select="handleSelect"
      :default-active="$route.meta.path || $route.path"
      @open="handleOpen"
      @close="handleClose"
    >
      <el-menu-item
        :index="item.path"
        v-for="(item, index) in menuList"
        :key="index"
      >
        <img :src="item.icon" class="ic" alt="" />
        <img :src="setIcon(item.icon)" class="ica" alt="" />
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {
  getAccountSystemInfo,
  getMenus,
  getFileListByIds,
} from "../util/api";

export default {
  name: "myAside",
  created() {
    this.queryHosInfo();
    let that = this;
    getMenus().then((res) => {
      let _list = [];
      let _res = [];
      res.responseData.forEach((item) => {
        if (item.items.length > 0 && item.menuModule == 'cm_hospital') {
          _res = [..._res, item.items];
        }
      });
      _list = this.getRoters(_res[0]);

      this.$store.commit("setMenu", _list);
      this.menuList = _list;
      let _router = this.$router.options.routes;
      _router[0].children = this.menuList;
      _router[0].redirect = this.menuList[0].path
      this.$router.addRoutes(_router);
      this.$store.commit('setMenu',_router[0].children)
    });
  },
  data() {
    return {
      logo: "",
      name: "",
      menuList: [],
    };
  },
  watch:{
    '$route':function (){
      if(this.$route.name){
        document.title = window.localStorage.getItem("hosName")+'-'+this.$route.name
      }else{
        document.title = window.localStorage.getItem("hosName")
      }
    }
  },
  methods: {
    getRoters(list) {
      let that = this;
      let _list = [];
      list.forEach((item) => {
        if (item.menuModule == "cm_hospital") {
          if (item.items.length > 1) {
            let _data = {
              path: item.routerLink,
              name: item.name,
              icon: item.icon,
              children: that.getRoters(item.items),
              component: require("@/pages" + item.url).default,
            };
            _list.push(_data);
          } else {
            let _data = {
              path: item.routerLink,
              name: item.name,
              icon: item.icon,
              component: require("@/pages" + item.url).default,
            };
            _list.push(_data);
          }
        }
      });
      return _list;
    },
    queryHosInfo() {
      getAccountSystemInfo().then((res) => {
        if (res.responseData.logo) {
          window.localStorage.setItem("hosLogo", res.responseData.logo);
          getFileListByIds([res.responseData.logo]).then((resF) => {
              this.logo = resF.responseData[0].fileUrl;
          }).catch(()=>{
            this.logo='/static/default-logo.png'
          });
          this.name = res.responseData.name;
        } else {
           this.logo='/static/default-logo.png'
          this.name = "";
        }
        if (res.responseData.name) {
          window.localStorage.setItem("hosName", res.responseData.name);
          document.title = res.responseData.name+'-'+this.$route.name ;
          this.name = res.responseData.name;
        } else {
          this.name = "";
        }
      });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      this.$router.push({
        path: key,
        params: { data: "query" },
      });
    },
    setIcon(str) {
      let index = str.indexOf(".png");
      return str.slice(0, index) + "-ac" + str.slice(index);
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-content {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  .hos {

    width: calc(100% - 60px);
    height:200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    border-bottom: #909090 0.052vw solid;
    border-right:#e6e6e6 1px solid  ;
    img {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      // background-color: #666666;
      //border: #e8556f 1px solid;
    }
    span {
      text-align: center;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      margin-top: 20px;
    }
  }
}
.ic,
.ica {
  width: 20px;
  height: 20px;
  margin-right: 22px;
}
/deep/ .el-submenu__title{
  margin: 0.521vw 0 0.521vw 1.042vw;
  font-size: 14px !important;
  padding: 0 ;
  line-height: 2.083vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 2.083vw;
  border-radius: 0.417vw 0 0 0.417vw;
  .ic{
    display: block;
  }
  .ica{
    display: none;
  }
}
.el-menu-item{
  margin: 10px 0 10px 20px;
  font-size: 14px;
  padding: 0;
  line-height: 50px;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 0.417vw 0 0 0.417vw;
  .ic{
    display: block;
  }
  .ica{
    display: none;
  }
}

.el-menu-item.is-active{
  background-color: #E8556F;
  color: #FFFFFF;
  .ic{
    display: none;
  }
  .ica{
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myAside.vue